export const getURLString = (baseURL, url) => `${baseURL}/${url}`;
export { user } from "./user";
